import { createFileRoute } from "@tanstack/react-router";
import { CelebrityResultPage } from "@/components/site/CelebrityResultPage";
import { ryneSandberg } from "@/lib/celebrity-results/ryne-sandberg";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "Ryne Sandberg Hair Transplant Results | RESTORE® Hair";
const DESC = "Remembering Hall of Famer Ryne Sandberg, a Chicago icon and RESTORE® client. See his hair restoration photos and story.";
const POSTER = "/img/r/wp-2024-08-ryne-sandberg-banner-img1-1.webp";

export const Route = createFileRoute("/results/ryne-sandberg")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://restorehair.com/results/ryne-sandberg/" },
      { property: "og:image", content: absoluteUrl(POSTER) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(POSTER) },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/results/ryne-sandberg/" },
    ],
  }),
  component: () => <CelebrityResultPage data={ryneSandberg} />,
});
